import styled from '@emotion/styled';
import AddItemButton from '../AddItemButton';
import emotionFirstChildSelector from '@/lib/styling/emotionFirstChildSelector';

const AddPartButton = styled(AddItemButton)({
  marginTop: 12,
  [emotionFirstChildSelector]: {
    marginTop: 0,
  },
});

export default AddPartButton;
